// Function to normalize URLs
const normalizeUrl = (url) => {
  if (url && (!url.includes('://') || url.startsWith('http://'))) {
    return `https://${url.replace(/^https?:\/\//, '')}`
  }
  return url
}

export default normalizeUrl
